"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gray = exports.orange = exports.yellow = exports.red = exports.green = exports.blue = void 0;
exports.blue = {
    '100': '#EAF7FF',
    '300': '#62C3FF',
    '500': '#0091EA',
    '700': '#005C95',
    '900': '#003251',
};
exports.green = {
    '100': '#EAF6E3',
    '300': '#B5DD9D',
    '500': '#72BF44',
    '700': '#457528',
    '900': '#274217',
};
exports.red = {
    '100': '#FFF0F0',
    '300': '#F68E83',
    '500': '#EF3824',
    '700': '#A11B0C',
    '900': '#520E06',
};
exports.yellow = {
    '100': '#FFEFC4',
    '300': '#FFD86F',
    '500': '#F7B500',
    '700': '#C28100',
};
exports.orange = {
    '100': '#FFF0D8',
    '300': '#FFCA85',
    '500': '#FF9000',
    '700': '#CC5F00',
};
exports.gray = {
    '100': '#F9F9F9',
    '200': '#EEEEEE',
    '300': '#CCCCCC',
    '400': '#BBBBBB',
    '500': '#999999',
    '600': '#888888',
    '700': '#666666',
    '800': '#444444',
    '900': '#333333',
};
//# sourceMappingURL=Palette.js.map